import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { Capacitor } from '@capacitor/core';
const isNative = Capacitor.isNativePlatform();

@Directive({
    selector: '[scrollbar]',
    standalone: false
})
export class ScrollbarDirective implements OnInit
{

	hostElement: HTMLElement

	constructor(
		public elementRef: ElementRef
	) { }

	ngOnInit()
	{
		const isNative = Capacitor.isNativePlatform();
		if (isNative) return;
		this.hostElement = this.elementRef.nativeElement;
		if (this.hostElement && this.hostElement.tagName && (
			this.hostElement.tagName == 'ION-CONTENT'
		))
		{
			let el = document.createElement('style')
			el.innerText = this.getCustomStyle();
			this.hostElement.shadowRoot.appendChild(el)
		}
		else if (this.hostElement && this.hostElement.tagName && (
			 this.hostElement.tagName == 'ION-SEGMENT'
		))
		{
			let el = document.createElement('style')
			el.innerText = this.getCustomStyle();
			this.hostElement.appendChild(el);
		}
	}

	getCustomStyle()
	{
		return `::-webkit-scrollbar {width: 6px;height: 6px;} ::-webkit-scrollbar-track {background: var(--mc-scrollbar-track, #efefef);} ::-webkit-scrollbar-thumb {background: var(--mc-scrollbar-thumb, rgba(0,0,0,0.15));border-radius: 8px;} ::-webkit-scrollbar-thumb:hover {background: var(--mc-scrollbar-thumb-hover, rgba(0,0,0,0.2));} .inner-scroll {scrollbar-width: thin}`
	}

}
